import React from "react"

const BLOBS = [
  // Top-left orange glow - secondary
  { style: { background: "#fa910a", opacity: 0.20 }, className: "top-[-12%] left-[-10%] w-[46vw] h-[46vw]" },
  // Sky blue - primary_lt upper-right
  { style: { background: "#b7e5ff", opacity: 0.55 }, className: "top-[2%] right-[-14%] w-[40vw] h-[40vw]" },
  // Sky blue - primary, lower-center
  { style: { background: "#0aa8fb", opacity: 0.25 }, className: "bottom-[-12%] left-[20%] w-[44vw] h-[44vw]" },
  // Orange spot lower-right - secondary
  { style: { background: "#fa910a", opacity: 0.25 }, className: "bottom-[2%] right-[4%] w-[32vw] h-[32vw]" },
]

export default function MainBackground({ className = "" }) {
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden="true">
      {/* Base */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-secondary/15" />

      {/* Orange + purple orbs */}
      <div className="absolute inset-0">
        {BLOBS.map((b, i) => (
          <div
            key={i}
            className={`absolute rounded-full blur-3xl ${b.className}`}
            style={{ ...b.style, }}
          />
        ))}
      </div>

      {/* Grid: lines + intersection dots in one layer at low opacity;
          diagonals in a separate layer so they can sit at 0.3 opacity. */}
      {/* <div
        className="absolute inset-0 opacity-[0.1]"
        style={{
          backgroundImage: [
            "radial-gradient(circle at 24px 24px, rgba(255,255,255,1) 3.5px, transparent 4.2px)",
            "radial-gradient(circle at 24px 24px, rgba(255,255,255,1) 1.75px, transparent 2.2px)",
            "linear-gradient(to right, rgba(255,255,255,0.5) 1px, transparent 1px)",
            "linear-gradient(to bottom, rgba(255,255,255,0.5) 1px, transparent 1px)",
          ].join(", "),
          backgroundSize: "192px 192px, 48px 48px, 48px 48px, 48px 48px",
          backgroundPosition: "0 0, 0 0, 24px 0, 0 24px",
        }}
      /> */}
      {/* <div
        className="absolute inset-0 opacity-[0.1]"
        style={{
          backgroundImage: [
            // Diagonal ╲ across each 8-block square (384px tile).
            "linear-gradient(135deg, transparent calc(50% - 0.6px), rgba(255,255,255,1) 50%, transparent calc(50% + 0.6px))",
            // Diagonal ╱ across each 8-block square.
            "linear-gradient(45deg, transparent calc(50% - 0.6px), rgba(255,255,255,1) 50%, transparent calc(50% + 0.6px))",
          ].join(", "),
          backgroundSize: "384px 384px, 384px 384px",
          backgroundPosition: "24px 24px, 24px 24px",
        }}
      /> */}
    </div>
  )
}

export const AldooComponent = {
  id: "MainBackground",
  component: MainBackground,
  description: "Backdrop for Pricing and Account pages.",
  input: {},
}
